import React, { useState } from "react";
import styles from "../../../styles/components/video.module.scss";
import {
  Box,
  Button,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
} from "@mui/material";
import assest from "../../../json/assest";
import {
  clipCopy,
  concatDownloadPath,
  truncateString,
} from "../../../lib/functions/utils.lib";
import AddOriginalVideoLinks from "./AddOriginalVideoLinks";
import AddSocialMediaUrls from "./AddSocialMediaUrls";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 199,
    height: 94,
    fontSize: theme.typography.pxToRem(12),
    boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25);",
    borderRadius: "10px 10px 0px 10px;",
    border: "none",
    padding: "10px 12px",
    margin: "0px",
  },
}));

const VideoDetailsPending = ({ data, refetchVideo }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      {data && (
        <Box className="VideocommonBox VideocommonBoxpending">
          <Box className={styles.ownerDetails}>
            <Box className={styles.commonHeading}>
              <h4>Video Details</h4>
            </Box>

            <Box className={styles.videoDetails}>
              {data.video_url && (
                <Box className={styles.videoDetailsBox}>
                  <h5>Public Post URL</h5>
                  <Box className={styles.videoInput}>
                    <input type="text" disabled placeholder={data.video_url} />
                    <Button onClick={() => clipCopy(data.video_url)}>
                      <img
                        src={assest.copyIcon}
                        width={13}
                        height={16}
                        alt=""
                      />
                    </Button>
                  </Box>
                </Box>
              )}

              <Box className={styles.videoDetailsBox}>
                <h5>Title </h5>
                <p>{data.title}</p>
              </Box>

              <Box className={styles.videoDetailsBox}>
                <h5>Description:</h5>
                <p>
                  {expanded
                    ? data.description
                    : truncateString(data.description, 200)}
                </p>
                {data.description?.length >= 200 && (
                  <Button
                    onClick={() => setExpanded(!expanded)}
                    className={styles.expandButton}
                  >
                    <img
                      src={assest.expandParaIcon}
                      width={14}
                      height={14}
                      alt=""
                    />
                  </Button>
                )}
              </Box>

              <Box className={styles.videoDetailsBoxLocation}>
                <Box className={styles.videoDetailsBox}>
                  <h5>Filming Location </h5>
                  <p>{data.country}</p>
                </Box>

                <Box className={styles.videoDetailsBox}>
                  <h5>Filming Date </h5>
                  <p>{data.when_filmed}</p>
                </Box>
              </Box>

              <>
                <AddOriginalVideoLinks
                  data={data}
                  refetchVideo={refetchVideo}
                />
                <AddSocialMediaUrls data={data} refetchVideo={refetchVideo} />
              </>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default VideoDetailsPending;
